var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pd-both" },
    [
      _c(
        "div",
        { staticClass: "matching-page-title" },
        [
          _c(
            "router-link",
            {
              staticClass: "matching-page-back",
              attrs: { to: "/recruiting/" + _vm.opportunityId }
            },
            [_vm._v("\n      ← Back to opportunity\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-20" },
        [
          _c(
            "md-card-header",
            {
              staticClass: "md-title matching-header",
              attrs: { "md-alignment": "space-between" }
            },
            [
              _c("div", [
                _vm._v("\n        Matching\n        "),
                _vm.matchingState === "ready"
                  ? _c("span", { staticClass: "matching-count" }, [
                      _vm._v(
                        "\n          (" +
                          _vm._s(_vm.matches.length) +
                          " candidates)\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.matchingState !== "loading"
                ? _c(
                    "div",
                    { staticClass: "matching-header-actions" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass:
                            "md-raised md-accent md-round capitalize md-white-color",
                          attrs: { disabled: _vm.matchingRunning },
                          on: { click: _vm.runMatching }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.matchingState === "empty"
                                  ? "Run matching"
                                  : "Re-run"
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "loosen-chips" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "loosen-chip",
                              class: {
                                "loosen-chip--active":
                                  _vm.loosenFilters.ignoreLocation
                              },
                              attrs: {
                                type: "button",
                                title:
                                  "Send location:[] + remote:true — bypass the strict location filter"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleLoosen("ignoreLocation")
                                }
                              }
                            },
                            [
                              _vm.loosenFilters.ignoreLocation
                                ? _c("span", [_vm._v("✕ ")])
                                : _vm._e(),
                              _vm._v("Ignore location\n          ")
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.opportunitySkills, function(skill) {
                            return _c(
                              "button",
                              {
                                key: "skill-" + skill,
                                staticClass: "loosen-chip",
                                class: {
                                  "loosen-chip--active": _vm.isSkillExcluded(
                                    skill
                                  )
                                },
                                attrs: {
                                  type: "button",
                                  title:
                                    "Exclude '" +
                                    skill +
                                    "' from the skills filter"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleExcludedSkill(skill)
                                  }
                                }
                              },
                              [
                                _vm.isSkillExcluded(skill)
                                  ? _c("span", [_vm._v("✕ ")])
                                  : _vm._e(),
                                _vm._v(_vm._s(skill) + "\n          ")
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.opportunityIndustries, function(ind) {
                            return _c(
                              "button",
                              {
                                key: "industry-" + ind,
                                staticClass: "loosen-chip",
                                class: {
                                  "loosen-chip--active": _vm.isIndustryExcluded(
                                    ind
                                  )
                                },
                                attrs: {
                                  type: "button",
                                  title:
                                    "Exclude '" +
                                    ind +
                                    "' from the industry filter"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleExcludedIndustry(ind)
                                  }
                                }
                              },
                              [
                                _vm.isIndustryExcluded(ind)
                                  ? _c("span", [_vm._v("✕ ")])
                                  : _vm._e(),
                                _vm._v(_vm._s(ind) + "\n          ")
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "loosen-chip",
                              class: {
                                "loosen-chip--active":
                                  _vm.loosenFilters.includeEmployer
                              },
                              attrs: {
                                type: "button",
                                title:
                                  "Allow candidates who already work at the employer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleLoosen("includeEmployer")
                                }
                              }
                            },
                            [
                              _vm.loosenFilters.includeEmployer
                                ? _c("span", [_vm._v("✕ ")])
                                : _vm._e(),
                              _vm._v("Include current employer\n          ")
                            ]
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.selectedIds.length > 0
                        ? _c(
                            "div",
                            { staticClass: "matching-bulk-bar" },
                            [
                              _c(
                                "span",
                                { staticClass: "matching-bulk-bar__count" },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.selectedIds.length))
                                  ]),
                                  _vm._v(" selected\n          ")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-accent md-round capitalize md-white-color",
                                  attrs: {
                                    disabled: _vm.pendingSelectedCount === 0
                                  },
                                  on: { click: _vm.approveSelected }
                                },
                                [
                                  _vm._v(
                                    "\n            Approve selected (" +
                                      _vm._s(_vm.pendingSelectedCount) +
                                      ")\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-accent md-round capitalize md-white-color m-left-10 md-orange",
                                  attrs: {
                                    disabled: _vm.pendingSelectedCount === 0
                                  },
                                  on: { click: _vm.rejectSelected }
                                },
                                [
                                  _vm._v(
                                    "\n            Reject selected (" +
                                      _vm._s(_vm.pendingSelectedCount) +
                                      ")\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-round capitalize m-left-10",
                                  on: { click: _vm.clearSelection }
                                },
                                [_vm._v("\n            Clear\n          ")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "md-card-content",
            [
              _vm.matchingState === "empty"
                ? _c("md-empty-state", {
                    attrs: {
                      "md-label": "No matches generated yet",
                      "md-description":
                        "Use the toolbar above — toggle any filter chips you want to loosen, then hit Run matching."
                    }
                  })
                : _vm.matchingState === "loading"
                ? _c(
                    "div",
                    {
                      staticClass: "matching-loader",
                      attrs: { role: "status", "aria-live": "polite" }
                    },
                    [
                      _vm._v("\n        Finding matches"),
                      _c(
                        "span",
                        {
                          staticClass: "matching-loader__dots",
                          attrs: { "aria-hidden": "true" }
                        },
                        [
                          _c("span", [_vm._v(".")]),
                          _c("span", [_vm._v(".")]),
                          _c("span", [_vm._v(".")])
                        ]
                      )
                    ]
                  )
                : [
                    _vm.matches.length === 0
                      ? _c("md-empty-state", {
                          attrs: {
                            "md-icon": "search_off",
                            "md-label": "No candidates matched",
                            "md-description": _vm.allChipsActive
                              ? "Even with every filter loosened, Vector DB found no matching alumni. The opportunity may be too narrow for this community, or there is not enough indexed data yet."
                              : _vm.anyChipActive
                              ? "No candidates matched with the current filters. Try excluding more chips above (or all of them) and hit Re-run."
                              : "No candidates matched. Try excluding a specific skill or industry chip above — or loosen Ignore location / Include current employer — and hit Re-run."
                          }
                        })
                      : _c(
                          "md-table",
                          { staticClass: "matching-table" },
                          [
                            _c(
                              "md-table-row",
                              [
                                _c(
                                  "md-table-head",
                                  {
                                    staticClass:
                                      "card-header matching-select-col"
                                  },
                                  [
                                    _c("md-checkbox", {
                                      attrs: {
                                        disabled: _vm.pendingCount === 0
                                      },
                                      model: {
                                        value: _vm.allPendingSelectedProxy,
                                        callback: function($$v) {
                                          _vm.allPendingSelectedProxy = $$v
                                        },
                                        expression: "allPendingSelectedProxy"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-table-head",
                                  { staticClass: "card-header" },
                                  [_vm._v("Candidate")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-table-head",
                                  { staticClass: "card-header" },
                                  [_vm._v("Score")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-table-head",
                                  { staticClass: "card-header" },
                                  [_vm._v("Match reasons")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-table-head",
                                  { staticClass: "card-header" },
                                  [_vm._v("Status")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-table-head",
                                  {
                                    staticClass:
                                      "card-header matching-actions-col"
                                  },
                                  [_vm._v("Actions")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.matches, function(m) {
                              return _c(
                                "md-table-row",
                                { key: m.advisor_id },
                                [
                                  _c(
                                    "md-table-cell",
                                    { staticClass: "matching-select-col" },
                                    [
                                      _c("md-checkbox", {
                                        attrs: {
                                          value: m.advisor_id,
                                          disabled: m.status !== "pending"
                                        },
                                        model: {
                                          value: _vm.selectedIds,
                                          callback: function($$v) {
                                            _vm.selectedIds = $$v
                                          },
                                          expression: "selectedIds"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-cell",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "match-name-link",
                                          attrs: {
                                            to: "/members/" + m.advisor_id
                                          }
                                        },
                                        [_vm._v(_vm._s(m.name))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "match-sub" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              (
                                                (m.dimensions &&
                                                  m.dimensions.location) ||
                                                []
                                              )
                                                .slice(0, 1)
                                                .join("")
                                            ) +
                                            "\n                "
                                        ),
                                        m.dimensions &&
                                        m.dimensions.education &&
                                        m.dimensions.education.length
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  · " +
                                                  _vm._s(
                                                    m.dimensions.education[0]
                                                  ) +
                                                  "\n                "
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("md-table-cell", [
                                    _vm._v(_vm._s(m.score + "%"))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-cell",
                                    _vm._l(_vm.matchTags(m), function(tag) {
                                      return _c(
                                        "span",
                                        {
                                          key: tag,
                                          staticClass: "skill-chip match-chip"
                                        },
                                        [_vm._v(_vm._s(tag))]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c("md-table-cell", [
                                    _c(
                                      "span",
                                      { class: _vm.statusColorClass(m.status) },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.statusMatchLabel(m.status)
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-cell",
                                    { staticClass: "matching-actions-col" },
                                    [
                                      m.status === "pending"
                                        ? [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-raised md-accent md-round capitalize md-white-color m-left-10",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.approveMatch(
                                                      m.advisor_id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Approve\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-raised md-accent md-round capitalize md-white-color m-left-10 md-orange",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.rejectMatch(
                                                      m.advisor_id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Reject\n                "
                                                )
                                              ]
                                            )
                                          ]
                                        : _c(
                                            "md-button",
                                            {
                                              staticClass:
                                                "md-raised md-accent md-round capitalize md-white-color m-left-10",
                                              on: {
                                                click: function($event) {
                                                  return _vm.resetMatch(
                                                    m.advisor_id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                Undo\n              "
                                              )
                                            ]
                                          )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                  ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e1b2cc7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1b2cc7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecruitingMatch.vue
// module id = null
// module chunks = 